import React from 'react';
import PropTypes from 'prop-types';
import { splitShortfall } from '../../utils/splitShortfall';
import { SplitShortfallCallout } from '../SplitShortfallFlag';

const SimpleFinancialSummaryCard = ({ ctrl }) => {
  const { calculated, formatCalculatedNumber, eventVenueNet, offer, budget, poolActive } = ctrl;

  // Potential Venue Earnings — event-level override if present, else per-offer showSummary
  const venueNetPotential = eventVenueNet?.offer != null
    ? eventVenueNet.offer
    : (calculated?.showSummary?.venueNetPotential || 0);

  const fmt = (n) => formatCalculatedNumber(n);
  const admissionTax = calculated?.showSummary?.admissionTax || 0;
  const shortfall = poolActive ? null : splitShortfall(calculated, offer, budget);

  return (
    <div className="simple-offer-card">
      <div className="simple-offer-card__eyebrow">FINANCIAL SUMMARY</div>

      <div className="simple-financial__metrics">
        <div className="simple-financial__metric">
          <span className="simple-financial__metric-value">{fmt(venueNetPotential)}</span>
          <span className="simple-financial__metric-label">OFFER</span>
          <span className="simple-financial__metric-name">Potential Venue Earnings</span>
        </div>
        {admissionTax > 0 && (
          <div className="simple-financial__metric" data-testid="simple-admission-tax">
            <span className="simple-financial__metric-value">{fmt(admissionTax)}</span>
            <span className="simple-financial__metric-label">ON TOP</span>
            <span className="simple-financial__metric-name">Admission Tax (pass-through)</span>
          </div>
        )}
      </div>

      {shortfall && (
        <div className="mt-3">
          <SplitShortfallCallout shortfall={shortfall} />
        </div>
      )}

      <a
        href="#"
        className="simple-deals__proforma-link"
        onClick={(e) => { e.preventDefault(); ctrl.setProFormaOpen(true); }}
      >
        View Pro-Forma ›
      </a>
    </div>
  );
};

SimpleFinancialSummaryCard.propTypes = {
  ctrl: PropTypes.object.isRequired,
};

export default SimpleFinancialSummaryCard;
